import moment from "moment/moment";
import type { TFunction } from "react-i18next";
import type { Column } from "react-table";
import styled from "styled-components";
import { RequestActionsCell } from "../components/tables/RequestActionsCell";
import { APPROVAL_STATUS, Request } from "../services/requests-service";

const ColoredSpan = styled.span`
  color: ${({ color }) => color};
`;

const getStatusColor = (status: APPROVAL_STATUS): string => {
	switch (status) {
    case APPROVAL_STATUS.PROCESSING:
      return "var(--textColor)";
		case APPROVAL_STATUS.APPROVED:
			return "#4AB0A6";
		case APPROVAL_STATUS.DECLINED:
			return "orange";
		case APPROVAL_STATUS.PENDING:
			return "var(--textColor)";
		case APPROVAL_STATUS.REVOKED:
			return "#EC3D08";
	}
};
const ApprovalStatus = ({
	approvalStatus,
}: {
	approvalStatus: APPROVAL_STATUS;
	translation: TFunction;
}): JSX.Element => (
	<ColoredSpan {...{ color: getStatusColor(approvalStatus) }}>
		{approvalStatus}
	</ColoredSpan>
);

export const getAccessRequestsTableColumnConfig = (
	t: TFunction,
): Column<Request>[] => [
	{
		Header: t("request.Id"),
		accessor: "id",
		Cell: ({ value }) => <span>{value || ""}</span>,
	},
	{
		Header: t("team.name.label"),
		accessor: "institutionName",
		Cell: ({ value }) => <span>{value || ""}</span>,
	},
	{
		Header: t("client.email"),
		accessor: "clientEmailAddress",
		Cell: ({ value }) => <span>{value || ""}</span>,
	},
	{
		Header: t("client.Id"),
		accessor: "clientId",
	},
	{
		Header: t("request.time"),
		accessor: "createdAt",
		Cell: ({ value }) => (
			<span>{moment(value).format("DD-MM-YYYY, h:mm:ss a")}</span>
		),
	},
	{
		Header: t("status"),
		accessor: "approvalStatus",
		Cell: ({ value }: { value: APPROVAL_STATUS }) => (
			<ApprovalStatus approvalStatus={value} translation={t} />
		),
		disableSortBy: true,
	},
	{
		Header: t("actions.title"),
		Cell: (props: { row: { original: Request } }) => (
			<RequestActionsCell data={props.row.original} />
		),
		disableSortBy: true,
	},
];
